<template>
    <div class="amusnet-jackpot">
        <iframe frameborder="0" width="100%" :src="cdn_url + '/jackpot/amusnet/' + domain_id + '/index.html?2'"></iframe>
    </div>
</template>

<script>
    export default{
        computed:{
            cdn_url(){
                return this.$store.getters['getCdnUrl'];
            },
            domain_id(){
                return process.env.VUE_APP_CLIENT_ID
            },
        },
    }
</script>


<style lang="scss">
    .amusnet-jackpot{
        overflow: hidden;
        iframe{
            margin-top: -160px;
            height: 250px;
        }
        &:hover{
            position: relative;
            z-index: 9999;
            overflow: inherit !important;
        }
    }
    #app.mobile{
        .amusnet-jackpot{
            iframe{
                height: 520px;
            }
        }
    }
</style>